export function formatarCPF(valor) {
    if (!valor) return '';

    let cpf = String(valor).replace(/\D/g, "");

    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return cpf;
}

export function formatarTamanhoArquivo(bytes) {
    return bytes > 1048576
        ? (bytes / 1048576).toFixed(1) + ' MB'
        : (bytes / 1024).toFixed(1) + ' KB';
}

export function formatarTelefone(numero) {
    if (!numero) return '';

    let telefone = String(numero).replace(/\D/g, "");
    telefone = telefone.slice(0, 11);

    telefone = telefone.replace(/^(\d{2})(\d)/g, "($1) $2");
    telefone = telefone.replace(/(\d)(\d{4})$/, "$1-$2");

    return telefone;
}

/**
 * Formata uma data para o padrão brasileiro (pt-BR) no fuso de São Paulo.
 *
 * @param {Date|string|number} data - A data a ser formatada.
 * @param {Object} [options={day: 'numeric', month: 'long', year: 'numeric'}] - Opções do Intl.DateTimeFormat.
 * @returns {string} A data formatada em texto.
 */
export function formatarDataParaPtBr(data, options = {day: 'numeric', month: 'long', year: 'numeric'}) {
    const dataObj = new Date(data);

    const opcoesLimpo = Object.fromEntries(
        Object.entries(options || {}).filter(([chave, valor]) => valor !== '' && valor != null)
    );

    const formatter = new Intl.DateTimeFormat('pt-BR', {
        ...opcoesLimpo,
        timeZone: 'America/Sao_Paulo',
    });

    return formatter.format(dataObj);
}

/**
 * Formata uma hora para o padrão brasileiro (pt-BR) no fuso de São Paulo.
 *
 * @param {Date|string|number} hora - A data/hora base para extrair a formatação.
 * @param {Object} [options={ hour: '2-digit', minute: '2-digit', second: '2-digit' }] - Opções do Intl.DateTimeFormat.
 * @returns {string} A hora formatada em texto.
 */
export function formatarHoraParaPtBr(hora, options = { hour: '2-digit', minute: '2-digit', second: '2-digit' }) {
    const dataObj = new Date(hora);

    //Remove opções com valores null
    const opcoesLimpo = Object.fromEntries(
        Object.entries(options || {}).filter(([chave, valor]) => valor !== '' && valor != null)
    );

    const formatter = new Intl.DateTimeFormat('pt-BR', {
        ...opcoesLimpo,
        timeZone: 'America/Sao_Paulo',
    });

    return formatter.format(dataObj);
}

export function slug(texto) {
    if (!texto) return "";

    return texto
        .toString() // Garante que é uma string
        .toLowerCase()
        .normalize('NFD') // Desmembra os acentos (ex: "á" vira "a" + "´")
        .replace(/[\u0300-\u036f]/g, '') // Remove os acentos que foram isolados acima
        .replace(/[^a-z0-9 -]/g, '') // Remove tudo que não for letra, número, espaço ou hífen
        .trim() // Remove espaços extras no início e no fim
        .replace(/\s+/g, '-') // Substitui um ou mais espaços por um único hífen
        .replace(/-+/g, '-'); // Garante que não haverá hífens duplicados (ex: "--")
}
